// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__JUTpn","form":"styles_form__Zbmt4"};